



















































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import Experience from "@/models/experience";
import InputSpinner from "@/components/InputSpinner.vue";
import CustomDatePicker from "@/components/CustomDatePicker.vue";
import RouteTranslations from "@/locales/routerTranslations";
import Reservation from "../../models/reservation";
import formRules from "../../helpers/formRules";
import utilitiesFunctions from "../../helpers/utilitiesFunctions";
import moment from "moment";
import * as _ from "lodash";
import { ExperienceAvailabilitiesRequests } from "@/helpers"
import ExperienceAvailabilityForDay from '@/models/experience-availability';
import { parseISO } from 'date-fns';

declare const fbq: any;

@Component({
  components: {
    CustomDatePicker,
    InputSpinner
  },
  data: {
    minPriceLabel: 0,
    maxPriceLabel: 0,

  },
  computed: {
    ...mapState({
      bookingDetails: (state: any) => {
        return state.booking.bookingDetails
      },
    }),
  },
})
export default class ReservationDialog extends Vue {
  bookingDetails!: Reservation;
  bookingObject = new Reservation();

  datetime = "";
  languages?: any[] = [];
  translations: any = RouteTranslations;
  rules: any = [(val: any) => val >= 0 || "Qty must be greater than 0"];
  menu: boolean = false;
  allowedDatesRange: any = [];
  dateSet = "";
  minDate: string = moment().toISOString();
  availabilityLoading = false;
  maxPriceLabel = 0;
  minPriceLabel = 0;


  isEvent: boolean = false;
  // scheduleList: Hours[] = [
  //   { id: "1", name: "08-09" },
  //   { id: "2", name: "10-11", disabled: true },
  //   { id: "3", name: "12-13" },
  //   { id: "4", name: "14-15" },
  //   { id: "5", name: "16-17" },
  //   { id: "6", name: "18-19" }
  // ];
  scheduleList: any = [];
  eventDates: any = []
  selectedSchedule: any = null;
  myRules = {
    select: formRules.mandatorySelect
  };
  formValid = false;

  @Prop({default: ""}) private experience!: Experience;
  @Prop({default: null}) private redeem!: any;
  @Prop({default: null}) private giftId!: any;
  @Prop({default: false}) private isGift!: any;
  @Prop({default: true}) public isRedeemCodeValid!: any;
  @Prop({default: false}) public isAlreadyRedeemed!: any;

  loading = false;
  private availabilities: ExperienceAvailabilityForDay[];


  totalAllItems(): number {
    return this.bookingObject.adults + this.bookingObject.priceLabels.map(e => e.quantity).reduce((x, y) => x + y, 0);
  }

  disableSaveButton(): boolean {
    let minParties = this.minPriceLabel;
    if (this.redeem) minParties = this.redeem.default_min_parties;
    return !this.totalAllItems() || (this.totalAllItems() < minParties) || (this.totalAllItems() > this.maxPriceLabel);
  }

  get total() {
    console.log(this.bookingDetails.priceLabels);
    (window as any).dbg = this.bookingDetails.priceLabels;
    const pricePerPerson = (this.bookingDetails.pricePerPerson || "0.0").toString().replace(',', '').replace('.', '');
    let price1 =
        (parseFloat(pricePerPerson) / 100) * (this.bookingObject.adults! - (this.redeem ? this.redeem.adults : 0));
    const priceLabels = this.bookingDetails.priceLabels
        .map(e => (parseFloat((e.price || "0.0").toString().replace(',', '').replace('.', '')) / 100)  * (e.quantity - (e.giftQuantity || 0)))
        .reduce((x, y) => x + y, 0.00);
    const priceExtras = this.bookingDetails.priceExtras
        .map(e => (parseFloat((e.price || "0.0").toString().replace(',', '').replace('.', '')) / 100) * (e.quantity - (e.giftQuantity || 0)))
        .reduce((x, y) => x + y, 0.00);

    return price1 + priceLabels + priceExtras;
  }

  created() {
    // this.$store.state.app.tagsList.forEach((tag: any) => {
    //   if (tag.code === "spklang") this.languages = tag.tags;
    // });
    // console.log(this.experience);

    this.languages = this.experience.experienceLanguagesTags;

    if (!this.isGift) {
      const mapDays: any = {
        mon: 1,
        tue: 2,
        wed: 3,
        thu: 4,
        fri: 5,
        sat: 6,
        sun: 7
      };
      this.allowedDatesRange = Object.entries(this.experience.days).map(
          ([day, available]) => {
            if (available) return mapDays[day];
          }
      );
    } else {
      this.maxPriceLabel = this.experience.maxParties;
      this.minPriceLabel = this.redeem ? 0 : this.experience.minParties;
    }
  }

  mounted() {
    this.bookingObject = new Reservation().localDeserialization({
      ...this.bookingDetails
    });

    console.log('object:', this.bookingObject);
    console.log('details:', this.bookingDetails);

    (window as any).r = this.redeem;
    this.bookingObject.isGift = this.isGift;
    if (this.redeem) {
      this.bookingObject.giftId = this.giftId;
      this.bookingObject.adults = this.redeem.adults;

      const rdmPriceLabels = [...this.redeem.priceLabels];

      for (let pl of this.bookingObject.priceLabels) {
        const index = rdmPriceLabels.findIndex(e => e.id === pl.id);
        if (index > -1) {
          pl.quantity = rdmPriceLabels[index].quantity || 0;
          pl.giftQuantity = pl.quantity;
          rdmPriceLabels.splice(index,1);
        }
      }

      if (rdmPriceLabels.length) {
        for (const pl of rdmPriceLabels) {
          this.bookingObject.priceLabels.push({
            id: pl.id,
            title: pl.title_translations['it'],
            titleTranslations: pl.title_translations,
            price: pl.price_cents,
            priceCurrency: pl.price_currency,
            priceSymbol: pl.price_symbol,
            quantity: pl.quantity,
            giftQuantity: pl.quantity,
            disable: true
          });
        }

      }


    }
    this.isEvent = (this.experience.experienceTypeTags || []).some(t => t.code == 'event');

    if (!this.isGift) {
      this.fetchEventsAvailabilities();


      const experience = this.experience,
          eventDate = experience.eventDate,
          eventDates = experience.eventDates;
      if (eventDate && (!eventDates || !eventDates.length)) {
        this.dateSet = this.experience.eventDate;
        this.bookingObject.startAt = this.dateSet;
      } else if (eventDates && eventDates.length) {
        this.dateSet = null;
      }

      this.disableTomorrow();
    }

    this.bookingObject.priceLabel = this.experience.priceLabel;
    this.bookingObject.price2Label = this.experience.price2Label;
    // this.getProductDetails(this.id);
    // console.warn("experience: ", this.experience);
    // this.allowedDatesRange = [
    //   UtilitiesFunctions.dateFormatter(new Date("05/10/2019"), "yyyy-m-d"),
    //   UtilitiesFunctions.dateFormatter(new Date("06/10/2019"), "yyyy-m-d")
    // ];
  }

  private fetchEventsAvailabilities() {
    if (this.isEvent) {
      const start = moment().utc(false).format('YYYY-MM-DD'),
          filters = `day_start=${start}&enable_lang_iso=${this.getIsoOfSelectedLanguage}`;
      this.periodSelected(filters, () => {
        this.eventDates = this.availabilities.filter(av => this.isDayAvailable(parseISO(av.day)))
            .reduce((availabilities: any[], av) => {
              const timetable = this.experience.availableTimesFor(this.availabilities, parseISO(av.day));
              const forDay = timetable.map(time => {
                const result = {text: '', day: av.day, time};
                const dateTime = `${av.day} ${time}`;
                result.text = _.capitalize(moment(dateTime).locale('it').format('dddd, DD MMMM YYYY [h]kk:mm'));
                return result;
              });
              return availabilities.concat(forDay);
            }, []);
      })
    }
  }

  allowedDates = (v) => false;

  isDayAvailable(val: Date) {
    const queriedDate = moment(val), strVal = queriedDate.format('YYYY-MM-DD');

    const closings = this.experience.closings;
    const isClosed = closings.find(closing => {
      const first = moment(closing.first),
          last = moment(closing.last),
          now = moment(val);

      return now.isBetween(first, last, 'day', '[]');
    }) != null;
    let allowedDates = false
    if (this.availabilities)
      allowedDates = this.experience.isDayAvailable(this.availabilities, queriedDate.toDate());

    return allowedDates && !isClosed;
  }

  disableTomorrow() {
    this.scheduleList = [];
    if (this.bookingObject.timetable && this.bookingObject.timetable.length > 0) {
      const today = moment().format("Y-MM-DD");
      const tomorrow = moment().add(1, 'days').format("Y-MM-DD");
      const selectedDate = this.bookingObject.startAt || today;
      const isTodaySelected = selectedDate === today;
      const isTomorrowSelected = selectedDate === tomorrow;

      this.bookingObject.timetable.forEach((time: string) => {
        let isDisabled = false;

        if (isTodaySelected || isTomorrowSelected) {
          const tomorrowAtIteratedTime = moment().add(1, 'days')
              .set({
                'hour': parseInt(time.substr(0, time.indexOf(':'))),
                'minute': parseInt(time.split(':')[1])
              });

          const difference = moment.duration(tomorrowAtIteratedTime.diff(moment()));
          if (difference.days() <= 0)
            isDisabled = true;
        }
        //Backend now handles this
        this.scheduleList.push({text: time, disabled: false});
      });
    }
  }

  languageSelect(v: any) {
    if (v) {
      // @ts-ignore
      const $ref = this.$refs["dt"];
      if ($ref) {
        // @ts-ignore
        $ref.clear();
        // @ts-ignore
        $ref.monthSelected(moment().format("YYYY-MM"));
      }

      this.dateSet = null;
      this.bookingObject.startAt = null;

      this.fetchEventsAvailabilities()
    }
  }

  monthSelected(id: string, v: any) {
    const day_start = moment(`${v}-01`).format('YYYY-MM-DD'),
        day_end = moment(day_start).endOf('month').format('YYYY-MM-DD'),
        filters = `day_start=${day_start}&day_end=${day_end}&enable_lang_iso=${this.getIsoOfSelectedLanguage}`;
    this.periodSelected(filters);
  }

  get getIsoOfSelectedLanguage() {
    return !!this.bookingObject.language ? (this.bookingObject.language.code as string).replace("lang_", "") : "";
  }

  periodSelected(filters: string, onAvailabilityLoaded?: () => void) {
    this.availabilityLoading = true;
    ExperienceAvailabilitiesRequests
        .with({
          ExperienceId: this.experience.id
        })
        .fetchAll(filters)
        .then(v => {
          this.availabilityLoading = false;
          this.availabilities = v.data;
          this.allowedDates = (date) => {
            date = parseISO(date);
            return this.isDayAvailable(date);
          }
          if (onAvailabilityLoaded) {
            onAvailabilityLoaded();
          }
        })
  }

  closeDialog() {
    this.$store.dispatch("app/closeDialog");
  }

  timeSelected(t) {
    this.maxPriceLabel = 0;
    this.minPriceLabel = 0;
    const availabilityForDay = this.availabilities.find(d => d.day == this.bookingObject.startAt);
    if (!availabilityForDay) return;
    const availabilityForTime = availabilityForDay.availabilities.find(av => av.time == t);
    if (!availabilityForTime) return;
    this.maxPriceLabel = availabilityForTime.calculcatedMaxAdults - availabilityForTime.adultsCount;
    this.minPriceLabel = availabilityForTime.adultsCount ? 0 : availabilityForTime.minAdults;
    //this.languages = availabilityForTime.languages;
  }

  updateSinglePicker(id: string, date: string) {
    console.warn("updateSinglePicker", id, date);
    this.bookingObject.startAt = date;
    const d = moment.utc(date) || moment.utc();

    if (this.experience.eventDates && this.experience.eventDates.length > 0 && this.isEvent) {
      const timetable = this
          .experience
          .eventDates
          .filter(date => utilitiesFunctions.onSameDay(d, moment.utc(date.event_date)))
          .map(date => moment.utc(date.event_date).format('HH:mm'))

      console.log(timetable);
      this.bookingObject.timetable = timetable;
    } else if (this.availabilities) {
      this.bookingObject.timetable = this.experience.availableTimesFor(this.availabilities, parseISO(d.format('YYYY-MM-DD')))
    }
    // this.bookingObject.time = '';

    if (id) {
      // @ts-ignore
      this.$refs["timeSelect"].reset();
    }

    this.disableTomorrow();
  }

  updateSingleDateEvent(eventDate: any) {
    if (!eventDate) return;

    this.bookingObject.time = eventDate.time;

    this.updateSinglePicker("", eventDate.day)
    this.timeSelected(eventDate.time)
  }


  sendFbPixelData() {
    let data: any = {
      content_category: this.bookingDetails.isGift ? "gift" : "book",
      content_ids: [this.bookingDetails.experience.id],
      currency: this.bookingDetails.experience.priceCurrency,

      contents: [
        {
          id: this.bookingDetails.priceLabel,
          quantity: this.bookingDetails.adults
        },

      ],
      value: this.bookingDetails.total
    };

    // fbq("track", "InitiateCheckout", data);
  }

  handleBook(link: string) {
    if (this.bookingObject.isGift) {
      this.languages.forEach(lang => {
        if (this.$i18n.locale == 'it' && lang.code == "lang_it") this.bookingObject.language = lang;
        if (this.$i18n.locale == 'en' && lang.code == "lang_en") this.bookingObject.language = lang;
      })
    }
    console.log(this.bookingObject.language)
    console.log(this.$i18n.locale)
    this.bookingObject.total = this.total;
    this.$store.dispatch("booking/setBookingDetails", {
      ...this.bookingObject,
      ...{redeem: this.redeem}
    });

      if (process.env.APP_ENV === "production") {
        this.sendFbPixelData();
      }

      const toRoute: string = this.translations[this.$i18n.locale][link].link;
      console.warn(toRoute)
      this.$router.push({ path: toRoute });
      this.$store.dispatch("app/closeDialog", {
        type: null,
        state: false
      });
    }

    getProductDetails(id: string) {
      this.loading = true;
      // ProductDetailsRequests.fetch(id)
      //   .then((response: any) => {
      //     this.productDetails = response;
      //     this.detailsLoading = false;
      //   })
      //   .catch((error: Error) => {
      //     this.detailsLoading = false;
      //     this.$store.dispatch("app/setSnackbarMessage", {
      //       message: error,
      //       color: "red"
      //     });
      //   });
    }

  get priceLabel() {
    return this.total === 0 && this.redeem
        ? this.$t("general.free")
        : "€ " + this.total.toFixed(2);
  }

  isGiftExpired() {
    return (
      this.redeem &&
      this.redeem.expires_at &&
      new Date(this.redeem.expires_at) < new Date()
    );
  }

  getExpiredDate() {
    return moment(this.redeem.expires_at).format("D MMMM YYYY");
  }
}
